export enum SubscriptionRenewalStatus {
  CanRenew = "Can renew",
  CannotRenew = "Cannot renew"
}
